import React from "react";
import { Container } from "reactstrap";
import BootstrapTable from 'react-bootstrap-table-next';
import { useState, useEffect } from "react";
import { get, post } from "../../Services/RestAPIService"
import paginationFactory from 'react-bootstrap-table2-paginator';

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

const PagesStarter = () => {
    document.title = "Starter Page | Veltrix - React Admin & Dashboard Template";

    const [data, setData] = useState({
        columns: [
            {
                text: "ID",
                dataField: "id",

                width: 100,
            },
            {
                text: "Name",
                dataField: "first_name",

                width: 150,
            },
            {
                text: "Gender",
                dataField: "gender",

                width: 270,
            },
            {
                text: "Email",
                dataField: "email",

                width: 200,
            },

            {
                text: "Verification Status",
                dataField: "is_verified",

                width: 150,
            },
            {
                text: "Last Login",
                dataField: "last_login",

                width: 100,
            },
        ],
        products: []
    });


    //   const defaultSorted = [{
    //     dataField: 'id',
    //     order: 'desc',

    //   }];


    const products = [];
    const columns = [{
        dataField: 'id',
        text: 'Product ID'
    }, {
        dataField: 'name',
        text: 'Product Name'
    }, {
        dataField: 'price',
        text: 'Product Price'
    }];


    const getUsersData = async () => {
        try {
            const usersData = await get(`v1/users/`);
            console.log(usersData);
            setData(prevState => ({ ...prevState, products: usersData.results }));
        } catch (error) {
            console.error('Error fetching user data:', error);
        }
    };

    useEffect(() => {
        getUsersData()
    }, []);



    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    {/* Render Breadcrumbs */}
                    <Breadcrumbs maintitle="Veltrix" title="Extra Pages" breadcrumbItem="Starter Page" />

                    

                    <BootstrapTable keyField='id' data={data.products} columns={data.columns}

                        // remote
                        // {...toolkitProps.baseProps}
                        // {...paginationTableProps}
                        // responsive

                        // hover
                        // classes={
                        //     "table align-middle table-nowrap table-check"
                        // }


                        striped={true}
                        bordered={false}
                        paginationLabel={true}
                        headerWrapperClasses={"table-light"}
                        pagination={paginationFactory()} />

                </Container>
            </div>
        </React.Fragment>
    );
};

export default PagesStarter;



// const getUsersData = async (page) => {
//     try {
//       const usersData = await get(`category/categories/?page=${page}&page_size=5`);

//       setTotalPages(Math.ceil(usersData.count / 5)); // Assuming each page contains 5 records

//       // Adding clickEvent to each object in the rows array
//       const modifiedRows = usersData.results.map(row => ({
//         ...row,
//         clickEvent: () => handleClick(row) // Passing the current row as parameter to handleClick
//       }));

//       // Updating the state with modified rows
//       setData(prevState => ({
//         ...prevState,
//         rows: modifiedRows
//       }));
//     } catch (error) {
//       console.error('Error fetching user data:', error);
//     }
//   };



// https://dummyimage.com/600x400/000/fff